import PropTypes from "prop-types";
import { IconAdd } from "@wwg/icons";
import { IconButton } from "../IconButton/IconButton";

/**
 * Special button for adding things. Takes custom label text as a child.
 */
export function AddButton({ onClick, children }) {
  return (
    <IconButton icon={<IconAdd size={20} />} onClick={onClick}>
      {children || "Add"}
    </IconButton>
  );
}

AddButton.propTypes = {
  /**
   * Callback to run when the user clicks the button.
   */
  onClick: PropTypes.func.isRequired,
};
